import { render, staticRenderFns } from "./FlowManageAdd.vue?vue&type=template&id=5b3e4cec&scoped=true"
import script from "./FlowManageAdd.vue?vue&type=script&lang=js"
export * from "./FlowManageAdd.vue?vue&type=script&lang=js"
import style0 from "./FlowManageAdd.vue?vue&type=style&index=0&id=5b3e4cec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3e4cec",
  null
  
)

export default component.exports